import { render, staticRenderFns } from "./IOSSuccessStep1.vue?vue&type=template&id=477a7050&scoped=true&"
import script from "./IOSSuccessStep1.vue?vue&type=script&lang=js&"
export * from "./IOSSuccessStep1.vue?vue&type=script&lang=js&"
import style0 from "./IOSSuccessStep1.vue?vue&type=style&index=0&id=477a7050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477a7050",
  null
  
)

export default component.exports